module.exports = __webpack_public_path__ + "static/assets/06e72ea220f551dc05a79c27d6f9e170.png";